import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import fetch from 'isomorphic-fetch';
import get from 'lodash/get';
import { parseData } from '../../../lib/helpers';
import { useFptiImpression } from '../../../lib/hooks';

import { AMPLITUDE } from '../../../lib/constants';

const { MAIN_GET_STARTED_REC_APP_TILE_CLICK } = AMPLITUDE;

const GetStartedToolTile = ({
  category,
  fptiClick,
  fptiImpression,
  pageLink,
  tool: {
    appIcon = '',
    shortDescription = '',
    appTitle = '',
    appKey = '',
    appFPTI = '',
    location = '',
    PSClickUrl = '',
    rank = '',
    priorityScore = ''
  } = {},
  toolTileProps: { experimentation = {} } = {}
}) => {
  const isColoredIconsEligible = get(experimentation, 'coloredIconsExp', false);
  const imgUrl = parseData(appIcon)[0] || {};
  const coloredImgUrl =
    isColoredIconsEligible && imgUrl.urlColored ? imgUrl.urlColored : '';
  const fptiObj = {
    prod: appFPTI,
    pageLink,
    categoryRank: category.rank,
    appKey,
    rank,
    priorityScore
  };
  const ref = useRef();
  useFptiImpression(ref, () => {
    fptiImpression(fptiObj);
  });

  const handleClickTool = () => {
    fptiClick({
      fptiLink: appFPTI,
      prod: appFPTI,
      pageLink,
      categoryRank: category.rank,
      appKey,
      rank,
      priorityScore,
      amplitude: true,
      event_name: MAIN_GET_STARTED_REC_APP_TILE_CLICK
    });
    fetch(PSClickUrl);
  };

  const route = `${`/appcenter/${category.location}`}/${location}`;

  return (
    <Link
      className="undo-link-styles"
      onClick={handleClickTool}
      to={route}
      ref={ref}
    >
      <div className="get-started-grid-item">
        <div className="get-started-grid-inner">
          <div className="get-started-grid-media">
            <div
              className={
                !isColoredIconsEligible
                  ? `lazyload get-started-grid-image old`
                  : `lazyload get-started-grid-image`
              }
              style={{
                background: `center center no-repeat`,
                backgroundSize: !isColoredIconsEligible ? '80%' : '100%'
              }}
              data-bg={coloredImgUrl || imgUrl.url}
            />
          </div>
          <div className="get-started-grid-item-text">
            <h2 className="get-started-grid-item-heading">{appTitle}</h2>
            <h4 className="get-started-grid-item-subheading">
              {shortDescription}
            </h4>
          </div>
        </div>
      </div>
    </Link>
  );
};

GetStartedToolTile.propTypes = {
  category: PropTypes.object,
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  pageLink: PropTypes.string,
  tool: PropTypes.object,
  toolTileProps: PropTypes.object
};

export default GetStartedToolTile;
